import React from "react";
import ChatAttachmentImage from "./chat-attachment-image/chat-attachment-image";
import { FileOutlined } from "@ant-design/icons";
import styles from "./chat-attachments.module.css";
import { downloadS3File } from "../../../../../../../../utils/common";

const ChatAttachments = ({ attachmentList }) => {
  return (
    <div className={styles["chat-attachments"]}>
      {attachmentList?.map((file, fIdx) => {
        const isImage = file?.mimetype?.startsWith("image/");
        const isPdf = file?.mimetype === "application/pdf";

        if (isImage || isPdf) {
          return (
            <a
              key={fIdx}
              href={file?.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["chat-attachment"]} ${styles[isImage ? "image-attachment" : "file-attachment"]}`}
            >
              {isImage ? (
                <ChatAttachmentImage src={file?.url} alt="attachment" />
              ) : (
                <div className={styles["file-icon-wrapper"]}>
                  <FileOutlined className={styles["file-icon"]} />
                  <span className={styles["file-name"]}>{file?.name}</span>
                </div>
              )}
            </a>
          );
        }

        return (
          <a
            key={fIdx}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              downloadS3File(file?.url, file?.name);
            }}
            className={`${styles["chat-attachment"]} ${styles["file-attachment"]}`}
          >
            <div className={styles["file-icon-wrapper"]}>
              <FileOutlined className={styles["file-icon"]} />
              <span className={styles["file-name"]}>{file?.name}</span>
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default ChatAttachments;
